export default "__VITE_ASSET__1f019b20__"